import { render, staticRenderFns } from "./SameCreation.vue?vue&type=template&id=5ed8a8d8&"
import script from "./SameCreation.vue?vue&type=script&lang=js&"
export * from "./SameCreation.vue?vue&type=script&lang=js&"
import style0 from "./SameCreation.vue?vue&type=style&index=0&id=5ed8a8d8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports